import { render } from "./FeShow.vue?vue&type=template&id=60576a2f"
import script from "./FeShow.vue?vue&type=script&lang=js"
export * from "./FeShow.vue?vue&type=script&lang=js"

import "./FeShow.vue?vue&type=style&index=0&id=60576a2f&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__